/* @flow */

export const RESET_AUTHENTICATION_LOGIN_SECTION =
  'RESET_AUTHENTICATION_LOGIN_SECTION';
export const SHOW_AUTHENTICATION_LOGIN_PASSWORD_SECTION =
  'SHOW_AUTHENTICATION_LOGIN_PASSWORD_SECTION';
